import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/car/reservations', config);
}

const getCarReservationDetail = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/car/reservations/detail/' + id);
}

const approveReservation = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/car/reservations/approve-reservation", formData);
};

const deliverReservation = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/car/reservations/deliver-reservation", formData);
};

const receiveReservation = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/car/reservations/receive-reservation", formData);
};

const getImageUrl = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/car/reservations/detail/show-image/" +  id, { responseType: "blob" });
};

export default {
    getAll,
    getCarReservationDetail,
    approveReservation,
    deliverReservation,
    receiveReservation,
    getImageUrl,
}
